import { Col, Layout, Row, Typography } from 'antd';
import React from 'react';

import LogoPXWhite from 'styles/images/DX_LOGO.svg';
import 'styles/leiLoginless.css';

const { Text } = Typography;

const Footer = () => {
    const isEnglish = window.location.href.includes('lang=en');

    return (
        <Layout.Footer className="lei-footer">
            {/* Top Row */}
            <Row align="top" className="lei-footer-row">
                {/* DX Logo */}
                <Col sm={24} md={6} className="lei-footer-logo-col">
                    <img src={LogoPXWhite} alt="DX Logo" className="lei-footer-dx-logo" />
                </Col>

                {/* Dokumenty */}
                <Col sm={24} md={14}>
                    <Row justify="space-evenly">
                        <div className="lei-footer-section">
                            <Text className="lei-footer-title">Dokumenty</Text>
                            <ul className="lei-footer-list">
                                <li>
                                    <Text className="lei-footer-item">Předpisy a pravidla společnosti</Text>
                                </li>
                            </ul>
                        </div>

                        {/* Odkazy */}

                        <div className="lei-footer-section">
                            <Text className="lei-footer-title">Odkazy</Text>
                            <ul className="lei-footer-list">
                                <li>
                                    <Text className="lei-footer-item">BCPP</Text>
                                </li>
                                <li>
                                    <Text className="lei-footer-item">PXE</Text>
                                </li>
                            </ul>
                        </div>
                    </Row>
                </Col>
                <Col sm={24} md={4}>
                    <a
                        href="https://www.cdcp.cz/centralni-depozitar-cennych-papiru-ziskal-prestizni-oceneni-v-soutezi-mastercard-banka-roku-2025/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img
                            width={130}
                            src="https://test.cdcp.cz/wp-content/uploads/FINTECH_MASTERCARD.png"
                            alt="GLEIF"
                        />
                    </a>
                </Col>
            </Row>
            {/* Logos Row */}
            <Row justify="center" align="middle" className="lei-footer-logos-row">
                <Col className="lei-footer-member-label">
                    <Text className="lei-footer-bottom-text-content">Jsme členem:</Text>
                </Col>
                <Col>
                    <div className="lei-footer-logos">
                        <a href="https://anna-web.org/" target="_blank" rel="noopener noreferrer">
                            <img
                                src="https://test.cdcp.cz/wp-content/uploads/ANNA.png"
                                alt="ANNA"
                                className="lei-footer-logo"
                            />
                        </a>
                        <a
                            href={isEnglish ? 'https://www.akatcr.cz/en-gb/' : 'https://www.akatcr.cz/'}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src={
                                    isEnglish
                                        ? 'https://test.cdcp.cz/wp-content/uploads/AKAT_EN.png'
                                        : 'https://test.cdcp.cz/wp-content/uploads/AKAT.png'
                                }
                                alt="AKAT"
                                className="lei-footer-logo"
                            />
                        </a>
                        <a href="https://ecsda.eu/" target="_blank" rel="noopener noreferrer">
                            <img
                                src="https://test.cdcp.cz/wp-content/uploads/ECSDA.png"
                                alt="ECSDA"
                                className="lei-footer-logo"
                            />
                        </a>
                        <a
                            href={isEnglish ? 'https://czechfintech.cz/en/' : 'https://czechfintech.cz/'}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src={
                                    isEnglish
                                        ? 'https://test.cdcp.cz/wp-content/uploads/FINTECH_EN.png'
                                        : 'https://test.cdcp.cz/wp-content/uploads/FINTECH.png'
                                }
                                alt="FINTECH"
                                className="lei-footer-logo"
                            />
                        </a>
                        <a href="https://www.gleif.org/en" target="_blank" rel="noopener noreferrer">
                            <img
                                src="https://test.cdcp.cz/wp-content/uploads/GLEIF.png"
                                alt="GLEIF"
                                className="lei-footer-logo"
                            />
                        </a>
                    </div>
                </Col>
            </Row>{' '}
        </Layout.Footer>
    );
};

export default Footer;
